import { useState } from 'react'

export interface Tab {
  key: string
  label: string
  renderElement?: JSX.Element
}

interface UseTabsProps {
  tabs: Tab[]
  defaultActiveKey?: string
}

export function tabsChangeComponents({ tabs, defaultActiveKey }: UseTabsProps) {
  const initialKey = defaultActiveKey || (tabs.length > 0 ? tabs[0].key : '')
  const [activeKey, setActiveKey] = useState(initialKey)

  // Get active tab index to pass to MainTabsV2
  const activeTabIndex = tabs.findIndex(tab => tab.key === activeKey)

  // onChange callback for tabs (MainTabsV2 usually passes index on change)
  const onChange = (index: number) => {
    const tab = tabs[index]
    if (tab) {
      setActiveKey(tab.key)
    }
  }

  return {
    activeKey,
    activeTabIndex,
    onChange,
  }
}
